import api from '../api';
import history from '../store/history';
import * as analyticsService from './analyticsService';
import * as localStorageService from './localStorageService';

export default { api, history, analyticsService, localStorageService };
